// @ts-nocheck
import React from 'react';
import Price from '../clientFormElements/Price';

const parseMoney = (value) => {
    const parsed = Number.parseFloat(String(value ?? '').replace(',', '.'));
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

const PriceElement = ({ formElement: { element_option, element_type, element_value, id, label, links, photo, placeholder, number, selection, cost, required } }) => {
    switch (element_type) {
        case 'price': {
            // Older elements can have cost=0 while their actual price remains
            // in element_value. Keep the unit-price display aligned with the
            // total calculation used by the public form.
            const storedCost = parseMoney(cost);
            const unitCost = storedCost > 0 ? storedCost : parseMoney(element_value);

            return (
                <>
                    <Price
                        id={id}
                        label={label}
                        placeholder={placeholder}
                        element_value={unitCost}
                        photo={photo}
                        
                    />

                </>)
        }
        default:
            return null;
    }
}

export default PriceElement
